import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { NOT_AUTHORIZED_PATH } from '@core/constants/permissions.const';
import { PermissionsService } from '@core/services/permissions.service';
import { getRoutePermission } from '@core/utils/route-permissions.util';

/**
 * @description
 * Permite la ruta solo si el perfil del usuario tiene el permiso declarado en
 * `data.permission`. Las rutas sin permiso declarado quedan accesibles para
 * cualquier usuario autenticado.
 *
 * Se registra como `canActivateChild` en el shell del dashboard y en los shells
 * con pestañas, de modo que se evalúa en cada nivel de ruta activado.
 *
 * Si la ruta denegada declara `data.backFallback`, se propaga como query param
 * `back` hacia `/not-authorized` para que el botón de esa pantalla regrese ahí
 * en lugar de al inicio.
 */
export const permissionGuard: CanActivateFn & CanActivateChildFn = (route) => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const permission = getRoutePermission(route);
  if (permission === null || permissions.has(permission)) {
    return true;
  }

  const backFallback = route.data['backFallback'] as string | undefined;
  if (!backFallback) {
    return router.parseUrl(NOT_AUTHORIZED_PATH);
  }

  return router.createUrlTree([NOT_AUTHORIZED_PATH], { queryParams: { back: backFallback } });
};
